import $http from '@Config/axios';
import { onlyNumber } from '@Util/functions';
import $store from '@Store';
import { DefaultPresenter } from './default-presenter';

const prefix = 'casa_repouso';
const entity = 'Casa de repouso';

function sanitize(restHome) {
	return {
		...restHome,
		cnpj: restHome.cnpj ? onlyNumber(restHome.cnpj) : null
	};
}

export const CasaRepousoPresenter = {
	...DefaultPresenter({ prefix, entity }),
	store(casaRepouso) {
		return new Promise((resolve, reject) => {
			$http.post(prefix, sanitize(casaRepouso))
				.then(response => {
					$store.dispatch('SHOW_SNACKBAR', { message: 'Casa de repouso salva com sucesso!' });
					resolve(response);
				})
				.catch(response => reject(response));
		});
	},
	update(casaRepouso, show_message = true) {
		return new Promise((resolve, reject) => {
			$http.put(`${prefix}/${casaRepouso.id}`, sanitize(casaRepouso))
				.then(response => {
					if (show_message)
						$store.dispatch('SHOW_SNACKBAR', { message: 'Casa de repouso salva com sucesso!' });
					resolve(response);
				})
				.catch(response => reject(response));
		});
	},
	orcamentos: id => $http.get(`${prefix}/${id}/orcamentos`)
};
